import React, { useContext, useState } from "react";
import { Nav, NavItem, Button } from "reactstrap";
import ProfileDropdown from "./ProfileDropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCrown, faCoins } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import NotificationDropdown from "./NotificationDropdown";
import Avatar from "../common/Avatar";
import { CurrencyContext } from "../../context/Context";
import ModalSelectedMoneyType from "../condominium/components/ModalSelectedMoneyType";
import RewardsCoinsBadge from "../rewards/RewardsCoinsBadge";
import { REWARDS_ENABLED } from "../../helpers/rewardsEnabled";

const TopNavRightSideNavItem = () => {
  const {
    condominium: { selectedCondominium, condominium },
    auth: {
      user: { role, hasMultipleProperties },
    },
    property: { selectedProperty, propertyLabel },
  } = useSelector((state) => state);

  const { currency: curr } = useContext(CurrencyContext);
  const [openMoneyModal, setOpenMoneyModal] = useState(false);

  // HO-HU-37: en la pantalla de "elegir propiedad" (mustSelectProperty en
  // DashboardRoutes.jsx) toda ruta que no sea /dashboard/app rebota de
  // vuelta ahi -- clickear una notificacion de ahi no lleva a ningun lado
  // todavia (su destino tambien rebotaria), así que no tiene sentido
  // mostrar la campana en ese momento.
  const mustSelectProperty =
    role === "property" && hasMultipleProperties && !selectedProperty;

  return (
    <>
      <Nav
        navbar
        className="navbar-nav-icons ml-auto flex-row align-items-center"
      >
        {selectedCondominium && role !== "root" && (
          <>
            <NavItem className="d-flex align-items-center mr-3 text-nowrap">
              <span className="font-weight-semi-bold text-600 mr-2">
                {condominium}
                {/* HO-HU-37: con varias propiedades vinculadas, sin esto no
                    habia forma de saber -mirando el navbar- cual de todas
                    quedo seleccionada (el condominio solo no alcanza
                    cuando 2 propiedades caen en el mismo condominio). */}
                {role === "property" && hasMultipleProperties && propertyLabel && (
                  <span className="text-500 fw-normal"> · {propertyLabel}</span>
                )}
              </span>
              <Avatar
                rounded="soft"
                shadow={true}
                size="s"
                src={`/assets/img/icons/Icono Condominio 2.png`}
              />
            </NavItem>
            <NavItem className="d-flex align-items-center mr-2">
              <Button
                color="falcon-default"
                size="sm"
                className="d-flex align-items-center px-2 py-1"
                style={{ borderRadius: '4px', fontSize: '12px' }}
                onClick={() => setOpenMoneyModal(true)}
              >
                <FontAwesomeIcon icon={faCoins} className="text-warning mr-1" />
                <span className="font-weight-bold">
                  {curr?.currency?.iso ? curr.currency.iso : "Moneda"}
                </span>
              </Button>
            </NavItem>
          </>
        )}
        {role === "root" && (
          <NavItem>
            Root
            <FontAwesomeIcon className="ml-2 mr-2" icon={faCrown} />
          </NavItem>
        )}
        {/* HO-TASK-290: Coins ganados sin ver (solo propietarios). */}
        {REWARDS_ENABLED && role === "property" && !mustSelectProperty && <RewardsCoinsBadge />}
        {!mustSelectProperty && role !== "provider" && <NotificationDropdown />}
        <ProfileDropdown />
      </Nav>

      <ModalSelectedMoneyType
        open={openMoneyModal}
        toggle={() => setOpenMoneyModal(!openMoneyModal)}
      />
    </>
  );
};

export default TopNavRightSideNavItem;
